module.exports = function() {
  return new Worker(__webpack_public_path__ + "efc06466de407e573230.worker.js");
};